export const ErrorPagesInfo = {
  400: {
    image:
      "https://faradars.org/wp-content/uploads/2025/12/13/693d4a28c9933-400-error-optimized.svg",
    title: "درخواست شما نامعتبر است.",
    subtitle: "لطفاً اطلاعات واردشده را بررسی کرده و مجدداً تلاش کنید.",
  },
  403: {
    image:
      "https://faradars.org/wp-content/uploads/2025/12/13/403-error-optimized.svg",
    title: "متأسفانه، شما دسترسی لازم برای مشاهده این صفحه را ندارید.",
    subtitle:
      "لطفاً مجدداً بررسی کنید که آیا با حساب کاربری صحیح وارد شده‌اید یا خیر.",
  },
  404: {
    image:
      "https://faradars.org/wp-content/uploads/2025/12/13/404-error-optimized.svg",
    title: "صفحه مورد نظر یافت نشد.",
    subtitle:
      "به نظر می‌رسد آدرس را اشتباه وارد کرده‌اید. برای یافتن مسیر درست، لطفاً به صفحه اصلی بازگشته و مجدداً تلاش کنید.",
  },
  500: {
    image:
      "https://faradars.org/wp-content/uploads/2025/12/13/500-error-optimized.svg",
    title: "ما موقتا در دسترس نیستیم.",
    subtitle:
      "تیم فنی فرادرس در حال بررسی است. لطفا چند دقیقه دیگر دوباره تلاش کنید.",
  },
};
